// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/rich_text.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_studyo_today_schools_v1_resources_text_format } from "./text_format_pb.js";

/**
 * Describes the file studyo/today/schools/v1/resources/rich_text.proto.
 */
export const file_studyo_today_schools_v1_resources_rich_text = /*@__PURE__*/
  fileDesc("CjFzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvcmljaF90ZXh0LnByb3RvEiFzdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMiVwoIUmljaFRleHQSDAoEdGV4dBgBIAEoCRI9CgZmb3JtYXQYAiABKA4yLS5zdHVkeW8udG9kYXkuc2Nob29scy52MS5yZXNvdXJjZXMuVGV4dEZvcm1hdEIpqgImU3R1ZHlvLlRvZGF5LlNjaG9vbHMuR3JwYy5WMS5SZXNvdXJjZXNiBnByb3RvMw", [file_studyo_today_schools_v1_resources_text_format]);

/**
 * Describes the message studyo.today.schools.v1.resources.RichText.
 * Use `create(RichTextSchema)` to create a new message.
 */
export const RichTextSchema = /*@__PURE__*/
  messageDesc(file_studyo_today_schools_v1_resources_rich_text, 0);

